import { Box, CircularProgress, Typography } from "@mui/material";

interface FullPageLoaderProps {
  text?: string;
}

const FullPageLoader = ({ text = "Loading…" }: FullPageLoaderProps) => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        backgroundColor: "background.default",
        zIndex: 2000,
      }}
    >
      <CircularProgress color="primary" />
      {text && (
        <Typography variant="body2" color="text.secondary">
          {text}
        </Typography>
      )}
    </Box>
  );
};

export default FullPageLoader;
